import React from 'react';

import { SentinelUser } from '@src/config/default/modules/Authentication/components/types/user/index';
import { formatLocalDateTime } from '@src/lib/date';

export type Props = {
  user: SentinelUser;
};

export default function BasicInfo({ user }: Props) {
  return (
    <div className="member-since">
      <p>
        <b>Member since:</b>
      </p>
      <p>{formatLocalDateTime(user.created)}</p>
    </div>
  );
}
